import React from 'react';
import LaboratoryResultsListWrapper from '../LaboratoryResultsList/LaboratoryResultsListWrapper';
import {
	LaboratoryResultResult,
	useLaboratoryResultQuery,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';

interface Props {
	laboratoryResultId: string;
}

const LaboratoryResult: React.FC<Props> = ({ laboratoryResultId }) => {
	const { data, isLoading, isFetching } = useLaboratoryResultQuery({
		where: { id: laboratoryResultId },
	});

	const laboratoryResult = data?.laboratoryResult;
	const patientId = laboratoryResult?.user?.id;

	if (isLoading || isFetching) {
		return <Loading />;
	}
	if (!laboratoryResult || !patientId) return <></>;

	return (
		<LaboratoryResultsListWrapper
			patientId={patientId}
			selectedItem={laboratoryResult as LaboratoryResultResult}
		/>
	);
};

export default LaboratoryResult;
